module.exports = __webpack_public_path__ + "static/media/circle.d88cce82.svg";